import styled from "styled-components";
import Typography from "@/foundation/Typography/V2";
import { FlexDiv } from "@/components/Atoms";

export const PaginationWrapper = styled(FlexDiv)`
  align-items: center;
  justify-content: center;
`;
export const Count = styled(Typography)`
  user-select: none;
  margin-right: 8px;
  &:last-child {
    margin-right: 0;
  }
  padding: 8px;
  text-align: center;
  cursor: pointer;
  color: ${({ theme, isActive }) =>
    isActive ? theme.colors.white : theme.colorsV2.gray.shade_700};
  background-color: ${({ theme, isActive }) =>
    isActive ? theme.colorsV2.shyft.purple_text : "transparent"};
  ${({ isNextPrevious }) =>
    !isNextPrevious &&
    `
  height:32px;
  width: 32px;
  border-radius:50%;
  `};
  ${({ isNextPrevious, disabled }) =>
    isNextPrevious &&
    disabled &&
    `
  opacity: 0.5;
  cursor: default;
  `}
`;
